import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectors } from "reducers/patient-outreaches";
import { setFilters } from "actions/patient-outreaches";

export const TILES = [
  { label: "Total in table today", field: "totalInTableToday", state: null },
  {
    label: "Unallocated & uncontacted",
    field: "unallocatedAndUncontacted",
    state: "Unallocated"
  },
  {
    label: "With coaches",
    field: "allocatedToCoachUncontacted",
    state: "AllocatedToCoach"
  },
  {
    label: "With Synthpop",
    field: "allocatedToSynthpopUncontacted",
    state: "AllocatedToSynthpop"
  },
  {
    label: "Contacted today",
    field: "contactedToday",
    state: "ContactedToday"
  },
  {
    label: "Failed automation",
    field: "failedAutomation",
    state: "FailedAutomation"
  }
];

const TotalCountsHeader = () => {
  const dispatch = useDispatch();
  const counts = useSelector(selectors.getGlobalCounts);

  if (!counts) return null;

  return (
    <div className="total-counts-header">
      {TILES.map(tile => (
        <button
          key={tile.field}
          type="button"
          className="count-tile"
          onClick={() =>
            tile.state && dispatch(setFilters({ outreachStates: [tile.state] }))
          }
          disabled={!tile.state}
        >
          <span className="count-tile__value">{counts[tile.field] ?? 0}</span>
          <span className="count-tile__label">{tile.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TotalCountsHeader;
